export default "__VITE_ASSET__e657176b__"